'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dTuple$0024package$0024$002dEmpty$002dTuple$0024 from "./scala.-Tuple$package$-Empty-Tuple$.js";
import * as $j_scala$002e$002dTuple1 from "./scala.-Tuple1.js";
import * as $j_scala$002e$002dTuple10 from "./scala.-Tuple10.js";
import * as $j_scala$002e$002dTuple11 from "./scala.-Tuple11.js";
import * as $j_scala$002e$002dTuple12 from "./scala.-Tuple12.js";
import * as $j_scala$002e$002dTuple13 from "./scala.-Tuple13.js";
import * as $j_scala$002e$002dTuple14 from "./scala.-Tuple14.js";
import * as $j_scala$002e$002dTuple15 from "./scala.-Tuple15.js";
import * as $j_scala$002e$002dTuple16 from "./scala.-Tuple16.js";
import * as $j_scala$002e$002dTuple17 from "./scala.-Tuple17.js";
import * as $j_scala$002e$002dTuple18 from "./scala.-Tuple18.js";
import * as $j_scala$002e$002dTuple19 from "./scala.-Tuple19.js";
import * as $j_scala$002e$002dTuple20 from "./scala.-Tuple20.js";
import * as $j_scala$002e$002dTuple21 from "./scala.-Tuple21.js";
import * as $j_scala$002e$002dTuple22 from "./scala.-Tuple22.js";
import * as $j_scala$002e$002dTuple3 from "./scala.-Tuple3.js";
import * as $j_scala$002e$002dTuple4 from "./scala.-Tuple4.js";
import * as $j_scala$002e$002dTuple5 from "./scala.-Tuple5.js";
import * as $j_scala$002e$002dTuple6 from "./scala.-Tuple6.js";
import * as $j_scala$002e$002dTuple7 from "./scala.-Tuple7.js";
import * as $j_scala$002e$002dTuple8 from "./scala.-Tuple8.js";
import * as $j_scala$002e$002dTuple9 from "./scala.-Tuple9.js";
import * as $j_scala$002eruntime$002e$002dTuple$002dX$002dX$002dL from "./scala.runtime.-Tuple-X-X-L.js";
var $p;
function $p_sr_Tuples$__specialCaseCons__O__s_Product__s_Product($thiz, x, self) {
  if (($j_scala$002e$002dTuple$0024package$0024$002dEmpty$002dTuple$0024.$m_T$package$EmptyTuple$() === self)) {
    return new $j_scala$002e$002dTuple1.$c_T1(x);
  }
  if ((self instanceof $j_scala$002e$002dTuple1.$c_T1)) {
    return new $j_java$002elang$002e$002dObject.$c_T2(x, self.mn);
  }
  if ((self instanceof $j_java$002elang$002e$002dObject.$c_T2)) {
    return new $j_scala$002e$002dTuple3.$c_T3(x, self.ac, self.ad);
  }
  if ((self instanceof $j_scala$002e$002dTuple3.$c_T3)) {
    return new $j_scala$002e$002dTuple4.$c_T4(x, self.pK, self.pL, self.pM);
  }
  if ((self instanceof $j_scala$002e$002dTuple4.$c_T4)) {
    return new $j_scala$002e$002dTuple5.$c_T5(x, self.ke, self.h0, self.kf, self.iU);
  }
  if ((self instanceof $j_scala$002e$002dTuple5.$c_T5)) {
    return new $j_scala$002e$002dTuple6.$c_T6(x, self.pN, self.pO, self.pP, self.pQ, self.pR);
  }
  if ((self instanceof $j_scala$002e$002dTuple6.$c_T6)) {
    return new $j_scala$002e$002dTuple7.$c_T7(x, self.pS, self.pT, self.pU, self.pV, self.pW, self.pX);
  }
  if ((self instanceof $j_scala$002e$002dTuple7.$c_T7)) {
    return new $j_scala$002e$002dTuple8.$c_T8(x, self.pY, self.pZ, self.q0, self.q1, self.q2, self.q3, self.q4);
  }
  if ((self instanceof $j_scala$002e$002dTuple8.$c_T8)) {
    return new $j_scala$002e$002dTuple9.$c_T9(x, self.q5, self.q6, self.q7, self.q8, self.q9, self.qa, self.qb, self.qc);
  }
  if ((self instanceof $j_scala$002e$002dTuple9.$c_T9)) {
    return new $j_scala$002e$002dTuple10.$c_T10(x, self.qd, self.qe, self.qf, self.qg, self.qh, self.qi, self.qj, self.qk, self.ql);
  }
  if ((self instanceof $j_scala$002e$002dTuple10.$c_T10)) {
    return new $j_scala$002e$002dTuple11.$c_T11(x, self.mo, self.mq, self.mr, self.ms, self.mt, self.mu, self.mv, self.mw, self.mx, self.mp);
  }
  if ((self instanceof $j_scala$002e$002dTuple11.$c_T11)) {
    return new $j_scala$002e$002dTuple12.$c_T12(x, self.my, self.mB, self.mC, self.mD, self.mE, self.mF, self.mG, self.mH, self.mI, self.mz, self.mA);
  }
  if ((self instanceof $j_scala$002e$002dTuple12.$c_T12)) {
    return new $j_scala$002e$002dTuple13.$c_T13(x, self.mJ, self.mN, self.mO, self.mP, self.mQ, self.mR, self.mS, self.mT, self.mU, self.mK, self.mL, self.mM);
  }
  if ((self instanceof $j_scala$002e$002dTuple13.$c_T13)) {
    return new $j_scala$002e$002dTuple14.$c_T14(x, self.mV, self.n0, self.n1, self.n2, self.n3, self.n4, self.n5, self.n6, self.n7, self.mW, self.mX, self.mY, self.mZ);
  }
  if ((self instanceof $j_scala$002e$002dTuple14.$c_T14)) {
    return new $j_scala$002e$002dTuple15.$c_T15(x, self.n8, self.ne, self.nf, self.ng, self.nh, self.ni, self.nj, self.nk, self.nl, self.n9, self.na, self.nb, self.nc, self.nd);
  }
  if ((self instanceof $j_scala$002e$002dTuple15.$c_T15)) {
    return new $j_scala$002e$002dTuple16.$c_T16(x, self.nm, self.nt, self.nu, self.nv, self.nw, self.nx, self.ny, self.nz, self.nA, self.nn, self.no, self.np, self.nq, self.nr, self.ns);
  }
  if ((self instanceof $j_scala$002e$002dTuple16.$c_T16)) {
    return new $j_scala$002e$002dTuple17.$c_T17(x, self.nB, self.nJ, self.nK, self.nL, self.nM, self.nN, self.nO, self.nP, self.nQ, self.nC, self.nD, self.nE, self.nF, self.nG, self.nH, self.nI);
  }
  if ((self instanceof $j_scala$002e$002dTuple17.$c_T17)) {
    return new $j_scala$002e$002dTuple18.$c_T18(x, self.nR, self.o0, self.o1, self.o2, self.o3, self.o4, self.o5, self.o6, self.o7, self.nS, self.nT, self.nU, self.nV, self.nW, self.nX, self.nY, self.nZ);
  }
  if ((self instanceof $j_scala$002e$002dTuple18.$c_T18)) {
    return new $j_scala$002e$002dTuple19.$c_T19(x, self.o8, self.oi, self.oj, self.ok, self.ol, self.om, self.on, self.oo, self.op, self.o9, self.oa, self.ob, self.oc, self.od, self.oe, self.of, self.og, self.oh);
  }
  if ((self instanceof $j_scala$002e$002dTuple19.$c_T19)) {
    return new $j_scala$002e$002dTuple20.$c_T20(x, self.oq, self.oB, self.oC, self.oD, self.oE, self.oF, self.oG, self.oH, self.oI, self.or, self.os, self.ot, self.ou, self.ov, self.ow, self.ox, self.oy, self.oz, self.oA);
  }
  if ((self instanceof $j_scala$002e$002dTuple20.$c_T20)) {
    return new $j_scala$002e$002dTuple21.$c_T21(x, self.oJ, self.oU, self.oW, self.oX, self.oY, self.oZ, self.p0, self.p1, self.p2, self.oK, self.oL, self.oM, self.oN, self.oO, self.oP, self.oQ, self.oR, self.oS, self.oT, self.oV);
  }
  if ((self instanceof $j_scala$002e$002dTuple21.$c_T21)) {
    return new $j_scala$002e$002dTuple22.$c_T22(x, self.p3, self.pe, self.ph, self.pi, self.pj, self.pk, self.pl, self.pm, self.pn, self.p4, self.p5, self.p6, self.p7, self.p8, self.p9, self.pa, self.pb, self.pc, self.pd, self.pf, self.pg);
  }
  if ((self instanceof $j_scala$002e$002dTuple22.$c_T22)) {
    return new $j_scala$002eruntime$002e$002dTuple$002dX$002dX$002dL.$c_sr_TupleXXL(new $j_java$002elang$002e$002dObject.$ac_O([x, self.po, self.pz, self.pD, self.pE, self.pF, self.pG, self.pH, self.pI, self.pJ, self.pp, self.pq, self.pr, self.ps, self.pt, self.pu, self.pv, self.pw, self.px, self.py, self.pA, self.pB, self.pC]));
  }
  throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(self);
}
export { $p_sr_Tuples$__specialCaseCons__O__s_Product__s_Product as $p_sr_Tuples$__specialCaseCons__O__s_Product__s_Product };
function $p_sr_Tuples$__xxlCons__O__sr_TupleXXL__sr_TupleXXL($thiz, x, xxl) {
  var arr = new $j_java$002elang$002e$002dObject.$ac_O(((1 + xxl.n()) | 0));
  arr.a[0] = x;
  var src = xxl.ff;
  var length = xxl.n();
  src.K(0, arr, 1, length);
  return new $j_scala$002eruntime$002e$002dTuple$002dX$002dX$002dL.$c_sr_TupleXXL(arr);
}
export { $p_sr_Tuples$__xxlCons__O__sr_TupleXXL__sr_TupleXXL as $p_sr_Tuples$__xxlCons__O__sr_TupleXXL__sr_TupleXXL };
/** @constructor */
function $c_sr_Tuples$() {
}
export { $c_sr_Tuples$ as $c_sr_Tuples$ };
$p = $c_sr_Tuples$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_sr_Tuples$;
/** @constructor */
function $h_sr_Tuples$() {
}
export { $h_sr_Tuples$ as $h_sr_Tuples$ };
$h_sr_Tuples$.prototype = $p;
$p.Y1 = (function(self) {
  if (($j_scala$002e$002dTuple$0024package$0024$002dEmpty$002dTuple$0024.$m_T$package$EmptyTuple$() === self)) {
    return $j_java$002elang$002e$002dObject.$m_s_Array$EmptyArrays$().wq;
  }
  if ((self instanceof $j_scala$002eruntime$002e$002dTuple$002dX$002dX$002dL.$c_sr_TupleXXL)) {
    return self.Y2();
  }
  if ((self !== null)) {
    return this.WH(self);
  }
  throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(self);
});
$p.WH = (function(self) {
  var arr = new $j_java$002elang$002e$002dObject.$ac_O(self.n());
  var i = 0;
  while ((i < arr.a.length)) {
    arr.a[i] = self.g(i);
    i = ((1 + i) | 0);
  }
  return arr;
});
$p.Uh = (function(xs) {
  switch (xs.a.length) {
    case 0: {
      return $j_scala$002e$002dTuple$0024package$0024$002dEmpty$002dTuple$0024.$m_T$package$EmptyTuple$();
      break;
    }
    case 1: {
      return new $j_scala$002e$002dTuple1.$c_T1(xs.a[0]);
      break;
    }
    case 2: {
      return new $j_java$002elang$002e$002dObject.$c_T2(xs.a[0], xs.a[1]);
      break;
    }
    case 3: {
      return new $j_scala$002e$002dTuple3.$c_T3(xs.a[0], xs.a[1], xs.a[2]);
      break;
    }
    case 4: {
      return new $j_scala$002e$002dTuple4.$c_T4(xs.a[0], xs.a[1], xs.a[2], xs.a[3]);
      break;
    }
    case 5: {
      return new $j_scala$002e$002dTuple5.$c_T5(xs.a[0], xs.a[1], xs.a[2], xs.a[3], xs.a[4]);
      break;
    }
    case 6: {
      return new $j_scala$002e$002dTuple6.$c_T6(xs.a[0], xs.a[1], xs.a[2], xs.a[3], xs.a[4], xs.a[5]);
      break;
    }
    case 7: {
      return new $j_scala$002e$002dTuple7.$c_T7(xs.a[0], xs.a[1], xs.a[2], xs.a[3], xs.a[4], xs.a[5], xs.a[6]);
      break;
    }
    case 8: {
      return new $j_scala$002e$002dTuple8.$c_T8(xs.a[0], xs.a[1], xs.a[2], xs.a[3], xs.a[4], xs.a[5], xs.a[6], xs.a[7]);
      break;
    }
    case 9: {
      return new $j_scala$002e$002dTuple9.$c_T9(xs.a[0], xs.a[1], xs.a[2], xs.a[3], xs.a[4], xs.a[5], xs.a[6], xs.a[7], xs.a[8]);
      break;
    }
    case 10: {
      return new $j_scala$002e$002dTuple10.$c_T10(xs.a[0], xs.a[1], xs.a[2], xs.a[3], xs.a[4], xs.a[5], xs.a[6], xs.a[7], xs.a[8], xs.a[9]);
      break;
    }
    case 11: {
      return new $j_scala$002e$002dTuple11.$c_T11(xs.a[0], xs.a[1], xs.a[2], xs.a[3], xs.a[4], xs.a[5], xs.a[6], xs.a[7], xs.a[8], xs.a[9], xs.a[10]);
      break;
    }
    case 12: {
      return new $j_scala$002e$002dTuple12.$c_T12(xs.a[0], xs.a[1], xs.a[2], xs.a[3], xs.a[4], xs.a[5], xs.a[6], xs.a[7], xs.a[8], xs.a[9], xs.a[10], xs.a[11]);
      break;
    }
    case 13: {
      return new $j_scala$002e$002dTuple13.$c_T13(xs.a[0], xs.a[1], xs.a[2], xs.a[3], xs.a[4], xs.a[5], xs.a[6], xs.a[7], xs.a[8], xs.a[9], xs.a[10], xs.a[11], xs.a[12]);
      break;
    }
    case 14: {
      return new $j_scala$002e$002dTuple14.$c_T14(xs.a[0], xs.a[1], xs.a[2], xs.a[3], xs.a[4], xs.a[5], xs.a[6], xs.a[7], xs.a[8], xs.a[9], xs.a[10], xs.a[11], xs.a[12], xs.a[13]);
      break;
    }
    case 15: {
      return new $j_scala$002e$002dTuple15.$c_T15(xs.a[0], xs.a[1], xs.a[2], xs.a[3], xs.a[4], xs.a[5], xs.a[6], xs.a[7], xs.a[8], xs.a[9], xs.a[10], xs.a[11], xs.a[12], xs.a[13], xs.a[14]);
      break;
    }
    case 16: {
      return new $j_scala$002e$002dTuple16.$c_T16(xs.a[0], xs.a[1], xs.a[2], xs.a[3], xs.a[4], xs.a[5], xs.a[6], xs.a[7], xs.a[8], xs.a[9], xs.a[10], xs.a[11], xs.a[12], xs.a[13], xs.a[14], xs.a[15]);
      break;
    }
    case 17: {
      return new $j_scala$002e$002dTuple17.$c_T17(xs.a[0], xs.a[1], xs.a[2], xs.a[3], xs.a[4], xs.a[5], xs.a[6], xs.a[7], xs.a[8], xs.a[9], xs.a[10], xs.a[11], xs.a[12], xs.a[13], xs.a[14], xs.a[15], xs.a[16]);
      break;
    }
    case 18: {
      return new $j_scala$002e$002dTuple18.$c_T18(xs.a[0], xs.a[1], xs.a[2], xs.a[3], xs.a[4], xs.a[5], xs.a[6], xs.a[7], xs.a[8], xs.a[9], xs.a[10], xs.a[11], xs.a[12], xs.a[13], xs.a[14], xs.a[15], xs.a[16], xs.a[17]);
      break;
    }
    case 19: {
      return new $j_scala$002e$002dTuple19.$c_T19(xs.a[0], xs.a[1], xs.a[2], xs.a[3], xs.a[4], xs.a[5], xs.a[6], xs.a[7], xs.a[8], xs.a[9], xs.a[10], xs.a[11], xs.a[12], xs.a[13], xs.a[14], xs.a[15], xs.a[16], xs.a[17], xs.a[18]);
      break;
    }
    case 20: {
      return new $j_scala$002e$002dTuple20.$c_T20(xs.a[0], xs.a[1], xs.a[2], xs.a[3], xs.a[4], xs.a[5], xs.a[6], xs.a[7], xs.a[8], xs.a[9], xs.a[10], xs.a[11], xs.a[12], xs.a[13], xs.a[14], xs.a[15], xs.a[16], xs.a[17], xs.a[18], xs.a[19]);
      break;
    }
    case 21: {
      return new $j_scala$002e$002dTuple21.$c_T21(xs.a[0], xs.a[1], xs.a[2], xs.a[3], xs.a[4], xs.a[5], xs.a[6], xs.a[7], xs.a[8], xs.a[9], xs.a[10], xs.a[11], xs.a[12], xs.a[13], xs.a[14], xs.a[15], xs.a[16], xs.a[17], xs.a[18], xs.a[19], xs.a[20]);
      break;
    }
    case 22: {
      return new $j_scala$002e$002dTuple22.$c_T22(xs.a[0], xs.a[1], xs.a[2], xs.a[3], xs.a[4], xs.a[5], xs.a[6], xs.a[7], xs.a[8], xs.a[9], xs.a[10], xs.a[11], xs.a[12], xs.a[13], xs.a[14], xs.a[15], xs.a[16], xs.a[17], xs.a[18], xs.a[19], xs.a[20], xs.a[21]);
      break;
    }
    default: {
      return new $j_scala$002eruntime$002e$002dTuple$002dX$002dX$002dL.$c_sr_TupleXXL(xs.x());
    }
  }
});
$p.Uk = (function(xs) {
  return ((xs.a.length <= 22) ? this.Uh(xs) : new $j_scala$002eruntime$002e$002dTuple$002dX$002dX$002dL.$c_sr_TupleXXL(xs));
});
$p.SU = (function(x, self) {
  return ((self instanceof $j_scala$002eruntime$002e$002dTuple$002dX$002dX$002dL.$c_sr_TupleXXL) ? $p_sr_Tuples$__xxlCons__O__sr_TupleXXL__sr_TupleXXL(this, x, self) : $p_sr_Tuples$__specialCaseCons__O__s_Product__s_Product(this, x, self));
});
var $d_sr_Tuples$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_sr_Tuples$, "scala.runtime.Tuples$", ({
  vO: 1
}));
export { $d_sr_Tuples$ as $d_sr_Tuples$ };
var $n_sr_Tuples$;
function $m_sr_Tuples$() {
  if ((!$n_sr_Tuples$)) {
    $n_sr_Tuples$ = new $c_sr_Tuples$();
  }
  return $n_sr_Tuples$;
}
export { $m_sr_Tuples$ as $m_sr_Tuples$ };
